import React, { useState, useEffect } from "react";
import { rutaAPI } from "../../../config";
import "./fotosCarrito.css";

export default function FotosCarrito() {
  const [foto, setFoto] = useState([]);
  const [image, setImage] = useState(null); // Imagen nueva
  const [imagenPreview, setImagenPreview] = useState(null); // Vista previa de imagen nueva
  const [precio, setPrecio] = useState(""); // Para capturar el precio
  const [descripcion, setDescripcion] = useState(""); // Para capturar la descripción
  const [imagePreviewEdit, setImagePreviewEdit] = useState({}); // Vista previa de edición
  const [selectedProduct, setSelectedProduct] = useState(null); // Producto seleccionado para edición

  // Obtener productos desde la API
  const url = `${rutaAPI}/api/mostrarCarrito`;
  const token = localStorage.getItem("ACCESS_TOKEN");
  const showData = async () => {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    setFoto(data.docs);
  };

  //======================FUNCIONES ONCHANGE================

  // Función para manejar la selección de imagen
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagenPreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setImage(null);
      setImagenPreview(null);
    }
  };

  //Funcion para manejar el precio
  const handlePrecioChange = (e) => {
    const cash = e.target.value;
    if (cash) {
      setPrecio(cash);
    } else {
      setPrecio(null);
    }
  };

  //Funcion para manejar la descripcion
  const handleDescripcionChange = (e) => {
    const descri = e.target.value;
    if (descri) {
      setDescripcion(descri);
    } else {
      setDescripcion(null);
    }
  };

  //=================FUNCION DE ENVIO A LA API============

  // Agregar nuevo producto a la API
  const addProduct = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("imagen", image);
    formData.append("precio", precio);
    formData.append("descripcion", descripcion);

    try {
      const response = await fetch(`${rutaAPI}/api/agregarImgCarrito`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`, // Incluye el token
        },
      });
      if (!response.ok) {
        throw new Error("Error al agregar producto");
      }
      showData();
      setImage(null);
      setImagenPreview(null);
      setPrecio(""); //Limpiar el precio despues de agregar
      setDescripcion(""); //Limpiar la descripcion despues de agregar
    } catch (error) {
      console.error("Error al agregar producto:", error);
    }
  };

  // Eliminar producto de la API
  const deleteProduct = async (id) => {
    try {
      await fetch(`${rutaAPI}/api/borrarImgCarrito/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`, // Incluye el token
        },
      });
      showData();
    } catch (error) {
      console.error("Error deleting product:", error);
    }
  };

  //======================== FUNCIONES DE EDICION ===================

  // Función para manejar la selección de imagen para edición
  const handleImageChangeEdit = (e, productId) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewEdit((prevState) => ({
          ...prevState,
          [productId]: reader.result,
        }));
      };
      reader.readAsDataURL(file);
    } else {
      setImagePreviewEdit((prevState) => ({
        ...prevState,
        [productId]: null,
      }));
    }
  };

  const precioChangeEdit = (e, productoId) => {
    const cash = e.target.value;
    if (cash) {
      setPrecio((prevPrecio) => ({
        ...prevPrecio,
        [productoId]: cash, // Guardamos el precio de cada producto por ID
      }));
    }
  };

  const descripcionChangeEdit = (e, productoId) => {
    const descri = e.target.value;
    if (descri) {
      setDescripcion((prevDescripcion) => ({
        ...prevDescripcion,
        [productoId]: descri, // Guardamos la descripcion de cada producto por ID
      }));
      console.log(descripcion);
    }
  };

  // Función para manejar la selección de producto
  const handleProductSelect = (product) => {
    setSelectedProduct(product);
    setImagePreviewEdit((prev) => ({
      ...prev,
      [product.id]: null,
    })); // Limpiar vista previa de la imagen de edición al seleccionar un nuevo producto
  };

  // Función para actualizar la imagen en la API
  const updateProduct = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    // Solo agregamos la imagen si existe una nueva
    if (image) {
      formData.append("imagen", image);
    }
    formData.append(
      "precio",
      precio[selectedProduct.id] || selectedProduct.precio
    ); // Usamos el precio actual si no se cambia
    formData.append(
      "descripcion",
      descripcion[selectedProduct.id] || selectedProduct.descripcion
    ); // Usamos la descripción actual si no se cambia

    try {
      const response = await fetch(
        `${rutaAPI}/api/editarImgCarrito/${selectedProduct.id}`,
        {
          method: "PUT",
          body: formData,
          headers: {
            Authorization: `Bearer ${token}`, // Incluye el token
          },
        }
      );
      if (!response.ok) {
        throw new Error("Error al actualizar la imagen.");
      }
      showData();
      setImage(null); // Limpiar imagen y vista previa
      setImagePreviewEdit({});
      setPrecio("");
      setDescripcion("");
      setSelectedProduct(null); // Limpiar producto seleccionado
    } catch (error) {
      console.error("Error al actualizar:", error);
    }
  };

  useEffect(() => {
    showData();
  }, []);

  return (
    <div className="imgRender">
      <div className="boxFormRender">
        <form className="formRender" onSubmit={addProduct}>
          <h2>Agregar Img a Carrito</h2>
          <input
            type="file"
            className="formInput"
            onChange={handleImageChange}
          />
          <input
            type="number"
            placeholder="Precio"
            className="formInput"
            value={precio}
            onChange={handlePrecioChange}
          />
          <input
            type="text"
            placeholder="Descripcion"
            className="formInput"
            onChange={handleDescripcionChange}
          />
          <button className="btnAgregarRender" type="submit">
            Agregar Producto
          </button>
          {imagenPreview && (
            <div className="boxMuestraRender">
              <img
                className="muestraRender"
                src={imagenPreview}
                alt="Vista Previa"
              />
            </div>
          )}
        </form>

        {foto.length > 0 && (
          <form className="formPerfilRender" onSubmit={updateProduct}>
            <h2>Editar Img de Carrito</h2>
            <ul className="listaRenderEditar">
              {foto.map((productos) => (
                <li key={productos.id}>
                  <label
                    htmlFor={`file-upload-${productos.id}`}
                    className="custom-file-upload"
                  >
                    Select
                  </label>
                  <input
                    type="file"
                    id={`file-upload-${productos.id}`}
                    className="formInputRender"
                    onChange={(e) => handleImageChangeEdit(e, productos.id)}
                    onClick={() => handleProductSelect(productos)}
                  />
                  <input
                    type="number"
                    placeholder="Precio"
                    className="formInput"
                    // Usamos el valor actual o el original
                    onChange={(e) => precioChangeEdit(e, productos.id)}
                    onClick={() => handleProductSelect(productos)}
                  />
                  <input
                    type="text"
                    placeholder="Descripcion"
                    className="formInput"
                    // Usamos el valor actual o el original
                    onChange={(e) => descripcionChangeEdit(e, productos.id)}
                    onClick={() => handleProductSelect(productos)}
                  />
                  {productos.ruta && !imagePreviewEdit[productos.id] && (
                    <div className="boxMuestraRender">
                      <img
                        className="muestraeRender"
                        src={`${rutaAPI}/${productos.ruta}`}
                        alt={productos.nombre}
                      />
                      <h5>{productos.precio}</h5>
                      <p>{productos.descripcion}</p>
                    </div>
                  )}
                  {imagePreviewEdit[productos.id] && (
                    <div className="boxMuestraRender">
                      <img
                        className="muestraRender"
                        src={imagePreviewEdit[productos.id]}
                        alt="Vista Previa"
                      />
                    </div>
                  )}
                  <div className="botonera">
                    <button className="btnAgregarRender" type="submit">
                      Actualizar
                    </button>
                    <button
                      className="btnEliminarRender"
                      type="button"
                      onClick={() => deleteProduct(productos.id)}
                    >
                      Eliminar
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </form>
        )}
      </div>
    </div>
  );
}
